module.exports = "/fonts/ElevanceSans-Bold.b9bfe0743fa6855966e96ebc7e1bf928.eot";